export const PASSWORD_REQUIREMENTS_MESSAGE =
  'Password must be at least 15 characters long and include characters from at least 3 of these 4 groups: uppercase letters, lowercase letters, numbers and special characters'

const passwordCharacterGroups = [/[A-Z]/, /[a-z]/, /\d/, /[^A-Za-z0-9]/]

export const validateStrongPassword = (password) => {
  if (password.length < 15) {
    return PASSWORD_REQUIREMENTS_MESSAGE
  }

  const matchedGroups = passwordCharacterGroups.filter((group) => group.test(password)).length
  return matchedGroups >= 3 ? '' : PASSWORD_REQUIREMENTS_MESSAGE
}